import TasksView from "@/modules/tasks/components/tasks-view/tasks-view";
import TaskDetailsSidebar from "@/modules/tasks/components/task-details/task-details-sidebar";
import useTrackTasks from "../../hooks/track-tasks";
import { Track } from "../../types";
import AddTrackTask from "./add-track-task";
import GenericAccordion from "@/modules/common/components/ui-kit/generic-accordion";

const TrackTasks = ({ track }: { track?: Track }) => {
  const {
    isLoading,
    tasks,
    completingTaskId,
    selectedTask,
    isSidebarOpen,
    openTask,
    closeSidebar,
    handleMarkComplete,
  } = useTrackTasks({
    trackUId: track?.uid,
  });

  return (
    <>
      <GenericAccordion title="Tasks" id="track-tasks" defaultExpanded rounded>
        <TasksView
          isLoading={isLoading}
          tasks={tasks}
          completingTaskId={completingTaskId}
          onTaskClick={openTask}
          onMarkComplete={handleMarkComplete}
        />

        <AddTrackTask track={track} />
      </GenericAccordion>

      <TaskDetailsSidebar
        task={selectedTask}
        isOpen={isSidebarOpen}
        onClose={closeSidebar}
        onMarkAsDone={handleMarkComplete}
        isUpdating={completingTaskId !== null}
      />
    </>
  );
};

export default TrackTasks;
